// extracted by mini-css-extract-plugin
export default {"root":"SuccessMessage_root__yKopN","icon":"SuccessMessage_icon__+R47L"};